var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"xl":_vm.content.columns,"cols":"12"}},[_c('h4',{staticClass:"lm-subtitle"},[_vm._v(_vm._s(_vm.content.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }